module.exports = __webpack_public_path__ + "img/codeIcon.2e27769d.jpg";